const SuccessLogo = () => (
  <svg
    width="150"
    height="160"
    viewBox="0 0 150 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0"
      maskUnits="userSpaceOnUse"
      x="31"
      y="45"
      width="87"
      height="90"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31 45H118V135H31V45Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.5036 82.2213C98.4825 82.9304 98.3667 83.9887 98.3351 84.2004L98.2719 84.7507C97.9772 87.6188 97.1981 90.2117 95.9453 92.54C94.5872 95.0694 92.8606 97.2389 90.7656 99.0381C88.6705 100.88 86.2386 102.319 83.4698 103.345C80.6904 104.372 77.7952 104.891 74.7632 104.891C71.4259 104.891 68.2991 104.256 65.3513 102.965C62.4035 101.684 59.8241 99.9271 57.6028 97.694C55.3498 95.4292 53.5916 92.8575 52.3599 89.9788C51.086 87.0155 50.4438 83.8617 50.4438 80.5174C50.4438 77.2154 51.0755 74.0405 52.3599 70.9925C53.0021 69.4896 53.7601 68.1032 54.6339 66.8121C55.5077 65.5315 56.5078 64.3251 57.6133 63.2138C59.8768 61.0336 62.4561 59.298 65.3618 58.0068C68.3096 56.7262 71.4469 56.0807 74.7737 56.0807C79.0375 56.0807 82.9223 57.0755 86.4176 59.044C87.8704 59.8377 89.1969 60.7585 90.4076 61.785L90.4813 61.8486C92.2711 63.6371 92.2395 66.5687 90.3866 68.3149C88.6179 69.9764 85.828 69.8601 84.112 68.135L84.1014 68.1244C84.0909 68.1032 84.0699 68.0927 84.0488 68.0715C83.8593 67.9127 82.6907 66.992 81.9537 66.5581C79.6902 65.1823 77.3004 64.4944 74.7842 64.4944C72.7419 64.4944 70.7521 64.9283 68.836 65.7855C66.8778 66.7274 65.2565 67.9022 63.9721 69.3203C62.6035 70.7808 61.4981 72.4741 60.6453 74.4003C59.8241 76.3264 59.4241 78.3584 59.4241 80.5068C59.4241 82.687 59.8347 84.7295 60.6453 86.6133C61.4981 88.5395 62.6035 90.2328 63.9721 91.6933C65.2986 93.1538 66.9199 94.3074 68.836 95.1646C70.6678 96.0642 72.6471 96.5193 74.7842 96.5193C76.4055 96.5193 77.9637 96.2653 79.4586 95.7467C80.9536 95.2704 82.3117 94.5826 83.554 93.683C84.7436 92.8258 85.8385 91.7568 86.8176 90.4656C87.3756 89.7354 87.8072 88.984 88.102 88.2114C88.3547 87.6928 88.3442 87.2484 88.0704 86.8885C87.7862 86.5181 87.3756 86.3382 86.8176 86.3382H82.4591C80.2272 86.3382 78.4269 84.5285 78.4269 82.2848C78.4269 80.0412 80.2272 78.2314 82.4591 78.2314H94.8293C96.8612 78.1997 98.5246 79.8507 98.5036 81.925V82.2213ZM74.5526 45H74.4579C54.8655 45 39 60.9596 39 80.6338C39 86.2641 40.2949 91.5875 42.6111 96.3182C42.6111 96.3182 46.2116 106.118 74.2579 134.894C74.321 134.958 74.4053 135 74.5 135C74.5842 135 74.679 134.958 74.7421 134.894C102.778 106.118 106.389 96.3182 106.389 96.3182C108.705 91.5875 110 86.2641 110 80.6338C110 60.949 94.124 45 74.5526 45Z"
        fill="white"
      />
    </g>
    <circle cx="3.90173" cy="97.1097" r="3.90173" fill="white" />
    <circle cx="108.381" cy="156.069" r="3.90173" fill="white" />
    <circle cx="148.049" cy="112.066" r="1.95086" fill="white" />
    <circle cx="47.4712" cy="136.777" r="1.95086" fill="white" />
    <circle cx="34.4655" cy="31.864" r="1.95086" fill="white" />
    <circle cx="104.479" cy="3.90173" r="3.90173" fill="white" />
  </svg>
);

export default SuccessLogo;
